module.exports = __webpack_public_path__ + "fonts/montserrat-bold-webfont.b2c0cde.woff";